import * as React from "react"
import Slider from "react-slick"
import CaseSlide from "./CaseSlide"
import { Col, Hidden, Row, Visible } from "react-grid-system"
import { ArrowButtonLeft, ArrowButtonRight } from "../../atoms/icons/ArrowButtonIcons"
import { theme } from "../../theme"
import { Spacer } from "../../atoms/spacers"
import styled from "styled-components"
import { useCaseCollection } from "../../../hooks/useCaseCollection"
import { CaseCarouselButton } from "./CaseCarouselButton"

interface Props {}

const MobileArrowButtons = styled.div`
  position: absolute;
  bottom: 2rem;
  left: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  z-index: 3;
`

const DesktopArrowButtons = styled.div`
  position: absolute;
  bottom: 50%;
  left: 0;
  z-index: 3;
  width: 100%;
  padding-inline: 1rem;
`

const CaseCarousel: React.FunctionComponent<Props> = ({}) => {
  const sliderRef = React.useRef()
  const { cases } = useCaseCollection()

  const [currentSlide, setCurrentSlide] = React.useState(0)

  const gotoNext = () => {
    //@ts-ignore
    sliderRef.current.slickNext()
  }

  const gotoPrev = () => {
    //@ts-ignore
    sliderRef.current.slickPrev()
  }

  const goToSpecificSlide = (slideNumber: number) => {
    //@ts-ignore
    sliderRef.current.slickGoTo(slideNumber)
  }

  const handleSliderAfterChange = (slideIndex: number) => {
    setCurrentSlide(slideIndex)
  }

  var settings = {
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: handleSliderAfterChange,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          centerMode: true,
          centerPadding: 0,
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
  }

  return (
    <div>
      <div style={{ position: "relative" }}>
        <Hidden xs sm md>
          <DesktopArrowButtons>
            <Row justify="between">
              <Col xs="content">
                <CaseCarouselButton
                  direction="left"
                  currentIndex={currentSlide}
                  onGoToAnotherIndex={goToSpecificSlide}
                  onClickArrowButton={gotoPrev}
                />
              </Col>
              <Col xs="content">
                <CaseCarouselButton
                  direction="right"
                  currentIndex={currentSlide}
                  onGoToAnotherIndex={goToSpecificSlide}
                  onClickArrowButton={gotoNext}
                />
              </Col>
            </Row>
          </DesktopArrowButtons>
        </Hidden>
        <Visible xs sm md>
          <MobileArrowButtons>
            <div onClick={gotoPrev}>
              <ArrowButtonLeft color={theme.colors.white} />
            </div>
            <Spacer spacing={4} />
            <div onClick={gotoNext}>
              <ArrowButtonRight color={theme.colors.white} />
            </div>
          </MobileArrowButtons>
        </Visible>
        <div>
          <Slider ref={sliderRef} {...settings}>
            {cases?.items?.map((item) => (
              <CaseSlide
                key={item.title}
                title={item.title}
                description={item.description}
                imgSrc={item.hero.image.url}
                imgAlt={item.hero.image.description}
                slug={item.title}
              />
            ))}
          </Slider>
        </div>
      </div>

      <link
        rel="stylesheet"
        type="text/css"
        charSet="UTF-8"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
      />
    </div>
  )
}

export default CaseCarousel
